import {
  getDetailIndex as getDetailIndexCommon,
  getDetailIndexCombine as getDetailIndexCombineOriginal,
  // getDetailIndexRank as getDetailIndexRankCommon,
  getDetailIndexRankCombine as getDetailIndexRankCombineOriginal,
  getSingleGameDetail as getSingleGameDetailCommon,
  getSingleGameDetailMobile as getGameDetailMobile,
} from '@intelligence/services/topcharts';
import {
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
  MObile_ENTITY_TYPE,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { toDateTypeLy, toDateTypeNor } from '@intelligence/utils/common';

import type { IGameType } from '@intelligence/types/common';
// import type { IReleaseDateByPlatformRes } from '@intelligence/pages/TopCharts/components/DetailsPage/ReleaseDateByPlatform/types';
import type { IDownloadableContent } from '@intelligence/pages/TopCharts/components/DetailsPage/DownloadableContent';

const handleCombineCommonParams = (payload: any): any => {
  if (!payload) return {};
  const payloadTmp = {
    ...payload,
    id: payload?.unified_id || '',
    date_type: toDateTypeLy[payload?.date_type] || '',
  };
  delete payloadTmp.unified_id;
  return payloadTmp;
};

const handleCombineCommonRes = (res: any): any => {
  if (!res) return {};
  const req = res?.req || {};
  const reqDateType = req?.date_type || 'daily';
  return {
    ...res,
    req: {
      ...req,
      date_type: toDateTypeNor[reqDateType] || '',
    },
  };
};

const parseReleaseDateByPlatformsJson = (json: string) => {
  if (!json) return [];
  try {
    return JSON.parse(json);
  } catch (e) {
    return [];
  }
};

const parseDownloadContentsRes = (
  jsonStr: string,
): {
  [key: string]: IDownloadableContent[];
} => {
  const downloadContents: {
    [key: string]: IDownloadableContent[];
  } = {};
  try {
    const downloadContentsTmp = JSON.parse(jsonStr);
    Object.keys(downloadContentsTmp).forEach((key) => {
      const downloadContentTmp = downloadContentsTmp[key]?.map((item: any) => ({
        name: item?.content_name || '',
        // image: item?.content_img || '',
        image: item?.content_cover || '',
        time: item?.content_release_time || '',
      }));
      downloadContents[key] = downloadContentTmp || [];
    });
  } catch (exception) {}
  return downloadContents;
};

const getDetailIndexCombine = async (payload: any): Promise<any> => {
  const payloadTmp = handleCombineCommonParams(payload);
  const res = await getDetailIndexCombineOriginal(payloadTmp);
  return handleCombineCommonRes(res);
};

const getDetailIndexRankCombine = async (payload: any): Promise<any> => {
  const payloadTmp = handleCombineCommonParams(payload);
  const res = await getDetailIndexRankCombineOriginal(payloadTmp);
  return handleCombineCommonRes(res);
};

const getSingleGameDetailCombine = async (payload: any): Promise<any> => {
  const { basic_info_others: basicInfoOthers } = payload || {};
  const {
    description,
    download_content: downloadContent,
    release_dates_by_platform: releaseDatesByPlatform,
    similar_apps: similarGames,
    image,
    images,
    video,
    video_screen: videoScreen,
    ...rest
  } = basicInfoOthers || {};
  const resData = {
    description,
    download_content: parseDownloadContentsRes(downloadContent),
    release_dates_by_platform: parseReleaseDateByPlatformsJson(releaseDatesByPlatform),
    image,
    images,
    similar_games: similarGames,
    video,
    video_screen: videoScreen,
    // 仅 mobile 需要用，pc、console 没有，所以固定返回空数组
    timelines: [],
    ...rest,
  };
  return Promise.resolve({
    code: 0,
    req: {},
    msg: 'ok',
    data: resData,
  });
};

export const createDetailIndexFetcher = (
  entityType: IGameType,
): ((payload: any) => Promise<any>) => {
  if (entityType === MObile_ENTITY_TYPE) return getDetailIndexCommon;
  return getDetailIndexCombine;
};

export const createDetailIndexRankFetcher = (): // entityType: IGameType,
((payload: any) => Promise<any>) =>
  // if (entityType === MObile_ENTITY_TYPE) return getDetailIndexRankCommon;
  getDetailIndexRankCombine;

export const createSingleGameDetailFetcher = (
  entityType: IGameType,
): ((payload: any) => Promise<any>) => {
  // combine，需要从 base_info 里获取
  if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) return getSingleGameDetailCombine;

  // pc、console 调用原 about 接口
  return async (subPayload: any) => {
    const subPayloadTmp = { ...subPayload };
    delete subPayloadTmp.basic_info_others;
    let res = await (entityType === MObile_ENTITY_TYPE
      ? getGameDetailMobile(subPayloadTmp)
      : getSingleGameDetailCommon(subPayloadTmp));
    if (res?.data) {
      // 需要把原接口 mobile、pc、console 返回的 download_content 加一层分类（固定为 all），从数据结构上跟 pcConsole 联合游戏详情页 保持一致
      const downloadContents = res?.data?.download_content || [];
      res = {
        ...res,
        data: {
          ...res?.data,
          download_content: {
            all: downloadContents,
          },
        },
      };
    }
    return res;
  };
};
